import React from 'react';

import { check } from '@/assets/icons';
import { Chip } from '@/components/shared/Chip/Chip';
import { UserAvatar } from '@/components/UserAvatar';

import styles from '../NewMessage.module.scss';

interface NewChatParticipantTileProps {
	userId: string;
	checked: boolean;
	name: string;
	isAdmin?: boolean;
	handlePress?: () => void;
}

export const NewChatParticipantTile = ({
	userId,
	name,
	isAdmin,
	checked,
	handlePress,
}: NewChatParticipantTileProps) => {
	const CheckIcon = check as React.FC<React.SVGProps<SVGSVGElement>>;
	return (
		<button
			type="button"
			onClick={handlePress}
			className={styles['new-message__card']}
		>
			<div className={styles['new-message__card-content']}>
				<UserAvatar size="x-small" userId={userId} />
				<div className="hsb-10" />
				<div className={styles['new-message__card-title']}>{name}</div>
			</div>
			{isAdmin && (
				<div className={styles['new-message__card-trailing-chip']}>
					<Chip variant="rounded" color="light-gray">Admin</Chip>
				</div>
			)}
			<div className={styles['new-message__card-icon-wrapper']}>
				<div
					className={[
						styles['new-message__card-icon-container'],
						checked
							? styles['new-message__card-icon-container--checked']
							: '',
					].join(' ')}
				>
					{checked && (
						<CheckIcon
							className={styles['new-message__card-icon']}
						/>
					)}
				</div>
			</div>
		</button>
	);
};
